<template>
    <div class="IperMatrizPeligrosCiudad">
        {{ ciudad }}
    </div>
</template>

<script>
export default {
    name: "IperMatrizPeligrosCiudad",

    props: {
        ciudad: String
    }
}
</script>